import { render, staticRenderFns } from "./DepositoUpdate.vue?vue&type=template&id=76c7b71c&scoped=true&"
import script from "./DepositoUpdate.vue?vue&type=script&lang=js&"
export * from "./DepositoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c7b71c",
  null
  
)

export default component.exports